import { Plugin } from 'rainbow-web-sdk/plugins/plugin';
import { LoggerService } from 'rainbow-web-sdk/services/core/logger.service';
import { BubbleServiceRB } from 'rainbow-web-sdk/services/bubbles/bubble.service';
import { PollsServiceRB } from 'rainbow-web-sdk/services/polls/polls.service';

export class PollsPlugin extends Plugin {
    public static initialize(): PollsPlugin {
        Plugin.initialize();

        if (!window.rainbow.plugins[PollsPlugin.name]) {
            const logger = LoggerService.getInstance();
            logger.info("[PollsPlugin] initialized");
            window.rainbow.plugins[PollsPlugin.name] = new PollsPlugin();
            BubbleServiceRB.getInstance();
            PollsServiceRB.getInstance();
        }
        return window.rainbow.plugins[PollsPlugin.name];
    }

    private constructor() {
        super();
    }
}
